import React from "react";
import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";
import { Print } from "./Print"

export default () => {
    return (
        <>
            <PageHeader />
            <DataBox />
            <Print />
        </>
    )
}